import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetDbpjKitWorkerJobRunsDocument,
  type GetDbpjKitWorkerJobRunsQuery,
  type GetDbpjKitWorkerJobRunsQueryVariables,
} from "~/features/dbpjkitWorkerJobs/gqls";
import { buildRunsVariables } from "~/features/dbpjkitWorkerJobs/utils/transformers";
import { useTenant } from "~/features/tenant/context";

interface UseDbpjkitWorkerJobRunsArgs {
  jobId: string;
  statusFilter: string | "all";
  pageIndex: number;
  pageSize: number;
}

/** Server-paginated run history for one job, optionally filtered by status (V1 parity). */
export function useDbpjkitWorkerJobRuns({ jobId, statusFilter, pageIndex, pageSize }: UseDbpjkitWorkerJobRunsArgs) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetDbpjKitWorkerJobRunsQuery, GetDbpjKitWorkerJobRunsQueryVariables>(
    GetDbpjKitWorkerJobRunsDocument,
    {
      variables: buildRunsVariables({ tenantId, jobId, statusFilter, pageIndex, pageSize }),
    },
  );
}
